import { Link } from "@/components/shared/link";
import { Bell } from "@/components/shared/icons";
import { Text, View } from "@/components/ui";
import { useAuthState } from "@/store/auth";

export function NotificationBadge() {
  const unreadNotificationCount = useAuthState(
    (state) => state.data.unreadNotificationCount,
  );

  return (
    <Link href="/notifications">
      <View className="flex size-10 items-center justify-center rounded-full bg-white">
        <Bell size={24} />
        {unreadNotificationCount > 0 && (
          <View className="absolute right-0 top-0 flex aspect-square h-[14px] w-[14px] items-center justify-center rounded-full bg-danger !p-0 text-xs">
            <Text className="text-[10px] text-white">
              {unreadNotificationCount > 9
                ? "9+"
                : String(unreadNotificationCount)}
            </Text>
          </View>
        )}
      </View>
    </Link>
  );
}
